export function scale(value, inMin, inMax, outMin, outMax) {
  return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
}

export function logScale(
  enteredValue,
  minEntry,
  maxEntry,
  normalizedMin,
  normalizedMax
) {
  var mx = Math.log2(enteredValue - minEntry) / Math.log2(maxEntry - minEntry);
  var preshiftNormalized = mx * (normalizedMax - normalizedMin);
  var shiftedNormalized = preshiftNormalized + normalizedMin;

  return shiftedNormalized;
}
